<template>
  <div class="industry-desc" :class="{ 'has-menu': showMenu, 'title-up': titleUp }">
    <div class="industry-content" :style="{ backgroundImage: `url(${industryInfo.bg})` }">
      <div class="text-content">
        <div class="text1" v-if="industryInfo.text1">{{ industryInfo.text1 }}</div>
        <div class="text2" v-if="industryInfo.text2">{{ industryInfo.text2 }}</div>
        <div class="text3" v-if="industryInfo.text3">{{ industryInfo.text3 }}</div>
      </div>
      <div v-if="showMenu" class="industry-menu">
        <div
          v-for="(item, k) in menuList"
          :key="k"
          class="option-item"
          :class="{ 'is-active': item.label === activeLabel }"
          @click="toPage(item)"
        >
          <div class="option-label">{{ item.label }}</div>
          <div class="option-subs list">
            <span v-for="(sub, si) in item.subs" :key="si">{{ sub }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showMenu: {
      type: Boolean,
      default: false
    },
    titleUp: {
      type: Boolean,
      default: false
    },
    industryInfo: {
      default: () => {
        return {
          bg: null,
          text1: '',
          text2: '',
          text3: ''
        }
      }
    }
  },
  data() {
    return {
      menuList: [
        {
          label: '化工材料行业',
          subs: ['涂料与油墨', '塑料与改性高分子', '电子化学品（半导体/面板材料）', '精细化工（表面活性剂、助剂、催化剂）', '工业胶粘剂与密封剂', '农化', '金属材料', '新能源材料与电池材料'],
          url: '/ChemicalIndustry'
        },
        {
          label: '食品饮料行业',
          subs: ['休闲零食', '饮料（含功能饮料）', '乳制品', '调味品', '预制菜 / 方便食品', '保健食品 / 功能食品', '宠物食品'],
          url: '/FoodBeverage'
        },
        {
          label: '日化美妆行业',
          subs: ['护肤品', '彩妆', '洗护用品', '口腔护理', '香氛', '家居清洁'],
          url: '/BeautyMakeup'
        },
        {
          label: '生命科学',
          subs: ['医疗器械', '制药', '医疗耗材', 'IVD试剂', '农药', '宠物药品'],
          url: '/MedicalEquipment'
        },
        {
          label: '离散行业',
          subs: ['芯片', '半导体', '3C电子'],
          url: '/Semiconductor'
        }
      ]
    }
  },
  computed: {
    activeLabel() {
      const path = this.$route.path
      if (path === '/MedicalEquipment') return '生命科学'
      if (path === '/Semiconductor' || path === '/ElectronTechnology') return '离散行业'
      return ''
    }
  },
  methods: {
    toPage(item) {
      if (this.$route.path === item.url) return
      this.$router.push(item.url)
    }
  }
}
</script>

<style lang="scss" scoped>
$img: "../../assets/images";

.industry-desc {
  position: relative;
  padding-top: 6.5rem;
  background-color: #f0f2f5;
  .industry-content {
    height: 48rem;
    // 图片加载完成前的占位底色，避免白字直接落在浅灰背景上看不见
    background-color: #14283f;
    background-size: cover!important;
    background-repeat: no-repeat!important;
    background-position: center center;
    box-sizing: border-box;
    position: relative;
    .text-content {
      padding-top: 16.1rem;
      text-align: center;
      .text1, .text3 {
        font-size: 3.6rem;
        color: #FFFFFF;
        line-height: 6rem;
        font-weight: 400;
      }
      .text2 {
        color: #FFFFFF;
        font-size: 4rem;
        font-weight: bold;
        line-height: 6rem;
      }
    }
  }

  &.has-menu {
    .industry-content {
      height: auto;
    }
    .text-content {
      padding-top: 4.8rem;
      padding-bottom: 8.4rem;
    }
    .industry-menu {
      position: relative;
      z-index: 2;
      display: flex;
      align-items: flex-start;
      gap: 2.4rem;
      padding: 1.6rem 1rem 2.4rem 20rem;
      box-sizing: border-box;
      .option-item {
        flex: 1;
        min-width: 0;
        cursor: pointer;
      }
      .option-label {
        margin-bottom: 0.8rem;
        font-size: 2rem;
        line-height: 2.8rem;
        font-weight: bold;
        color: #8ec5ff;
        text-shadow: 0 0.1rem 0.4rem rgba(0, 0, 0, 0.65);
      }
      .option-item:hover .option-label {
        text-decoration: underline;
      }
      .option-subs {
        font-size: 1.5rem;
        line-height: 2.4rem;
        color: #fff;
        text-shadow: 0 0.1rem 0.4rem rgba(0, 0, 0, 0.65);
        &.list span {
          display: block;
        }
      }
    }
  }

  &.has-menu.title-up {
    .text-content {
      padding-top: 8.4rem;
    }
  }
}

@import "@/styles/mixins.scss";

@include mobile {
  .industry-desc {
    padding-top: 5.6rem;
    .industry-content {
      height: auto;
      min-height: 22rem;
      .text-content {
        width: 100%;
        padding: 4.8rem 1.6rem 2.4rem;
        .text1,
        .text2,
        .text3 {
          white-space: normal;
          word-break: break-word;
        }
        .text1,
        .text3 {
          font-size: 1.8rem;
          line-height: 2.8rem;
        }
        .text2 {
          font-size: 2.4rem;
          line-height: 3.2rem;
        }
      }
    }

    &.has-menu {
      .industry-content {
        height: auto;
        min-height: 0;
      }
      .text-content {
        padding: 2.4rem 1.6rem 1.2rem;
      }
      .industry-menu {
        position: relative;
        gap: 1.2rem;
        padding: 1.2rem 1.2rem 1.6rem;
        overflow-x: auto;
        .option-item {
          flex: 1 0 14rem;
        }
        .option-label {
          font-size: 1.3rem;
          line-height: 1.8rem;
          margin-bottom: 0.4rem;
        }
        .option-subs {
          font-size: 1.1rem;
          line-height: 1.6rem;
        }
      }
    }

    &.has-menu.title-up {
      .text-content {
        padding-top: 1.2rem;
      }
    }
  }
}
</style>
